<body class="ltr main-body leftmenu">
	<form autocomplete="off" class="p-0" [formGroup]="deptSubMappingForm" novalidate>
		<div class="main-content side-content pt-0 ml-0">
			<div class="main-container container-fluid">
				<div class="inner-body" [formGroup]="deptSubMappingForm">
					<div class="row row-sm add-form">
						<div class="col-lg-12 col-md-12">
							<div class="card custom-card">
								<div class="card-body">
									<div class="row">
										<div class="col-md-9">
											<div class=" d-flex align-items-center pl-3">
												<img alt="Logo" src="../../assets/img/CollegeMaster.png"
													class="mh-45px pb-2">
												<div class="ml-2">
													<h3 class="main-content-label mb-1"><b>
															Department Subject Mapping
														</b></h3>
													<p class="text-muted card-sub-title mb-0">
														Department Subject Mapping Record
													</p>
												</div>
											</div>
										</div>
									</div>
									<hr class="mt-2">
									<div class="row clearfix">
										<!-- <div class="col-sm-4"> -->
											<!-- <div class="form-group"> -->
												<!-- <div class=""> -->
													<!-- <div class="row"> -->
                                                        <!-- <div class="col-sm-3">
                                                            <div class="form-group">
                                                                <div class="">
                                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                                        <mat-label>Session</mat-label>
                                                                        <mat-select #select232 placeholder="Session" class="colorblack"
                                                                            formControlName="DmSnNo" required>
                                                                            <mat-select-filter *ngIf="select232.focused"
                                                                                [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                                [array]="sessionList"
                                                                                (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                                            <mat-option *ngFor="let item of SessionFilterList"
                                                                                [value]="item.SnNo" (click)="fetchSession()">
                                                                                {{item.SnName}}
                                                                            </mat-option>
                                                                        </mat-select>
                                                                        <mat-error class="margin_tp"
                                                                            *ngIf="deptSubMappingForm.controls['DmSnNo'].touched && deptSubMappingForm.controls['DmSnNo'].errors?.required">
                                                                            Mandatory
                                                                        </mat-error>
                                                                    </mat-form-field>
                                                                </div>
                                                            </div>
                                                        </div> -->
                                                        <div class="col-sm-3">
                                                            <div class="form-group">
                                                                <div class="">
                                                                    <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label> Department </mat-label>
                                                                    <mat-select #select583 class="colorblack"
                                                                        formControlName="DmId">
                                                                        <mat-select-filter *ngIf="select583.focused"
                                                                            [placeholder]="'Filter'"
                                                                            [displayMember]="'DeptName'"
                                                                            [array]="DepartmentList"
                                                                            (filteredReturn)="filteredDepartmentList =$event"></mat-select-filter>
                                                                        <mat-option
                                                                            *ngFor="let item of filteredDepartmentList"
                                                                            [value]="item.DeptCode" (click)="getDepartmentData()">
                                                                            {{item.DeptName}}
                                                                        </mat-option>
                                                                    </mat-select>
                                                                    <mat-error class="margin_tp"
                                                                    *ngIf="deptSubMappingForm.controls['DmId'].touched && deptSubMappingForm.controls['DmId'].errors?.required">
                                                                    Mandatory
                                                                </mat-error>
    
                                                                </mat-form-field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <div class="form-group">
                                                                <div class="">
                                                                    <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label>
                                                                        Course
                                                                    </mat-label>
                                                                    <mat-select #select2389 placeholder="Course"
                                                                        formControlName="DmCoCode" required>
                                                                        <mat-select-filter *ngIf="select2389.focused"
                                                                            [placeholder]="'Filter'"
                                                                            [displayMember]="'CoName'"
                                                                            [array]="CourseList"
                                                                            (filteredReturn)="filteredListCourse =$event">
                                                                        </mat-select-filter>
                                                                        <mat-option
                                                                            *ngFor="let item of filteredListCourse"
                                                                            [value]="item.CoCode" (click)="fetchDeptSubjectData(item)" (click)="getCourseSub(item)" >
                                                                            {{item.CoCode}} - {{item.CoName}}
                                                                        </mat-option>
                                                                    </mat-select>
                                                                    <mat-error class="margin_tp "
                                                                        *ngIf="deptSubMappingForm.controls.DmCoCode.touched && deptSubMappingForm.controls.DmCoCode.errors?.required">
                                                                        Mandatory
                                                                    </mat-error>
                                                                </mat-form-field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="col-sm-3">
                                                            <div class="form-group">
                                                                <div class="">
                                                                    <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label>
                                                                        Exam
                                                                    </mat-label>
                                                                    <mat-select #select2333 placeholder="Exam"
                                                                        formControlName="DmEmId" required>
                                                                        <mat-select-filter *ngIf="select2333.focused" 
                                                                            [placeholder]="'Filter'"
                                                                            [displayMember]="'EmName'"
                                                                            [array]="examList"
                                                                            (filteredReturn)="filteredListExam =$event">
                                                                        </mat-select-filter>
                                                                        <mat-option *ngFor="let item of filteredListExam"
                                                                            [value]="item.EmId" (onSelectionChange)="fetchSrNo(item)" (click)="getExmSub(item)">
                                                                            {{item.EmCoCode}}-{{item.EmName}}
                                                                        </mat-option>
                                                                    </mat-select>
                                                                    <mat-error class="margin_tp "
                                                                        *ngIf="deptSubMappingForm.controls.DmEmId.touched && deptSubMappingForm.controls.DmEmId.errors?.required">
                                                                        Mandatory
                                                                    </mat-error>
                                                                </mat-form-field>
                                                                </div>
                                                            </div>
                                                        </div> -->
                                                        <!-- <div class="col-sm-3">
                                                            <div class="form-group">
                                                                <div class="">
                                                                    <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label> Year </mat-label>
                                                                    <input readonly class="color" matInput
                                                                      placeholder="Year" formControlName="DmEmSrNo">
                                                                   
                                                                </mat-form-field>
                                                                </div>
                                                            </div>
                                                        </div> -->
                                                       
													<!-- </div> -->
												<!-- </div> -->
											<!-- </div> -->
										<!-- </div> -->
                                         <div class="col-sm-8"></div>
                                         <div class="col-sm-4" *ngIf="table">
                                            <span class="floatright mt-1">
                                                <button id="Save" type="button" class="btn btn-primary btn-icon-text" (click)="submit()">
                                                    <span style="display: contents; align-items: center;">
                                                        <img width="20vh" src="../../assets/img/save.gif">
                                                       Save
                                                    </span>
                                                </button>
                                            </span>
                                         <span class="floatright mt-1 mr-3">
                                            <button id="Back" type="button" class="btn btn-primary btn-icon-text"
                                                (click)="back()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/turn-left.gif">
                                                    {{'header.college-mapping.table.Back' | translate}}
                                                </span>
                                            </button>
                                        </span>
                                    </div>
									</div>
									<hr class="mt-1">

                                    <div class="table-responsive table-container" *ngIf="table">
                                        <table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
                                                    <th class="f600 text-center" width="5%"> Action </th>
                                                    <th class="f600 text-center" width="5%"> Year </th>
                                                    <th class="f600 text-left" width="90%"> Subject Name </th>
                                                    <!-- <th class="f600 text-left" width="5%"> Practical </th> -->
                                                </tr>
                                            </thead>
                                            <tbody id="table_data" formArrayName="ExamSubArray">
                                                <tr *ngFor="let subject of getControls(); let i = index "
                                                    [formGroupName]="i">
                                                    <td class="text-center">
                                                        <mat-checkbox id="{{subject.value.DmSubEsId}}"
                                                            [formControl]="subject.get('subjectcheckbox')">
                                                        </mat-checkbox>
                                                    </td>
                                                    <td class="text-center">{{ subject.get('DmEmSrNo').value }}
                                                    </td>
                                                    <td class="text-left">{{ subject.get('EsName').value }}
                                                    </td>
                                                    <!-- <td class="text-center">
                                                        <mat-checkbox
                                                            [formControl]="subject.get('practicalcheckbox')">
                                                        </mat-checkbox>
                                                    </td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
								</div>

							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</form>
</body>